import {ApplyStateType, ActionType, reducerStoreType} from "./types";

const defaultState = {
    ApplyInfo: {
        clientId: '',
        email: '',
        sellAmt: '',
        buyCurrency: '',
        useDefaultBankInfo: 1,
        bankName: '',
        bankAccountNo: '',
        bankAccountName: '',
        bankAddress: '',
        swiftcode: '',
    },
	CurrencyList: {
		list: []
	},
	DetailInfo: {
		exchangeRate: 0,
		purchaseAmount: '',
		salesAmount: ''
	}
}

const exchangeApply = (state: ApplyStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
		case 'SET_CURRENCY_LIST':
		    return {
		        ...state,
		        CurrencyList: action.payload
		    }
		case 'BANK_CHANGE':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					useDefaultBankInfo: action.payload.useDefaultBankInfo
				}
		    }
		case 'SET_AMT':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					sellAmt: action.payload.sellAmt
				},
				DetailInfo: {
					...state.DetailInfo,
					salesAmount: action.payload.sales
				}
		    }
		case 'SET_CURRENCY':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					buyCurrency: action.payload.buyCurrency
				},
				DetailInfo: {
					...state.DetailInfo,
					exchangeRate: action.payload.exchangeRate,
					purchaseAmount: action.payload.purchaseAmount
				}
		    }
		case 'SET_PURCHASE':
			return {
				...state,
				DetailInfo: {
					...state.DetailInfo,
					purchaseAmount: action.payload.purchaseAmount
				}
			}
		case 'SET_BANK_NAME':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					bankName: action.payload.bankName
				}
		    }
		case 'SET_BANK_ACCOUNTNO':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					bankAccountNo: action.payload.bankAccountNo
				}
		    }
		case 'SET_BANK_ACCOUNTNAME':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					bankAccountName: action.payload.bankAccountName
				}
		    }
		case 'SET_BANK_ADDRESS':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					bankAddress: action.payload.bankAddress
				}
		    }
		case 'SET_BANK_SWIFTCODE':
		    return {
		        ...state,
		        ApplyInfo: {
					...state.ApplyInfo,
					swiftcode: action.payload.swiftcode
				}
		    }
		case 'RESET_APPLY_INFO':
			return {
				...state,
				ApplyInfo: {...defaultState.ApplyInfo},
				DetailInfo: {...defaultState.DetailInfo}
			}
        default:
            return state;
    }
}

export const applyInfo = (state:reducerStoreType) => (state.exchangeApply.ApplyInfo)
export const currencyList = (state:reducerStoreType) => (state.exchangeApply.CurrencyList.list)
export const detailInfo = (state:reducerStoreType) => (state.exchangeApply.DetailInfo)
export default exchangeApply